// ============== СУЩЕСТВУЮЩИЕ РОУТЫ ==============
export const MAIN_ROUTE = "/";
export const CLUSTERS_ROUTE = "/clusters";
export const CLUSTER_ROUTE = "/cluster";
export const STORES_ROUTE = "/stores";
export const STORE_ROUTE = "/store";
export const LOGIN_ROUTE = "/login";
export const PRIVACY_POLICY_ROUTE = "/privacy_policy";
export const USER_AGREEMENT_ROUTE = "/user_agreement";
export const PERSONAL_DATA_AGREEMENT_ROUTE = "/personal_data_agreement";
export const CART_ROUTE = "/cart";
export const COMPLEX_CART_ROUTE = "/complex_cart";
export const CHECKOUT_ROUTE = "/checkout";
export const COMPLEX_CHECKOUT_ROUTE = "/complex_checkout";
export const PROFILE_ROUTE = "/profile";
export const CITY_ROUTE = "/city";
export const cityRoute = (id: number | string) => `${CITY_ROUTE}/${id}`;

// ============== РОУТЫ КАБИНЕТА ==============
export const ORDERS_ROUTE = "/profile/order";
export const ADDRESSES_ROUTE = "/profile/address";
export const BONUSES_ROUTE = "/profile/bonus";
export const COMPLEX_ORDERS_ROUTE = "/profile/complex-order";
export const FAVORITES_ROUTE = "/profile/favorite";

export const clusterRoute = (id: number | string) => `${CLUSTER_ROUTE}/${id}`;
export const storeRoute = (
  storeId: number | string,
  clusterId?: number | string,
) =>
  clusterId
    ? `${STORE_ROUTE}/${storeId}?cluster=${clusterId}`
    : `${STORE_ROUTE}/${storeId}`;

// ============== НОВЫЕ РОУТЫ (LOGMALL) ==============
export const ITEMS_ROUTE = "/item";
export const ITEM_ROUTE = "/item";
export const CATEGORIES_ROUTE = "/category";
export const CATEGORY_ROUTE = "/category";
export const PROMOS_ROUTE = "/promo";

export const itemRoute = (id: number | string) => `${ITEM_ROUTE}/${id}`;
export const categoryRoute = (id: number | string) => `${CATEGORY_ROUTE}/${id}`;
export const promoRoute = (id: number | string) => `${PROMOS_ROUTE}/${id}`;

// ============== ХЕЛПЕРЫ КАБИНЕТА ==============
export const orderRoute = (id: number | string) => `${ORDERS_ROUTE}/${id}`;
export const complexOrderRoute = (id: number | string) =>
  `${COMPLEX_ORDERS_ROUTE}/${id}`;
